export const Logo = () => (
  <svg height="100%" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M41.5 120.8C30.7 110.6 23.9 96.0999 23.9 80C23.9 63.9 30.7 49.4 41.5 39.2H21.2C12.5 50.3 6.5 64.4 6.5 80C6.5 95.5999 12.5 109.7 21.2 120.8H41.5Z" fill="#1B1811" />
    <path d="M118.5 120.8H138.8C147.5 109.7 153.5 95.5999 153.5 80C153.5 64.4 147.5 50.3 138.8 39.2H118.5C129.3 49.4 136.1 63.9 136.1 80C136.1 96.0999 129.3 110.6 118.5 120.8Z" fill="#1B1811" />
  </svg>
);
